/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { select, withQuery } from '../../core/themev2';
import { Icon } from '../../icons';
import { Container, FeatureLabel, DropdownInput, OptionsContainer, Select, OneOptionView } from './styles';

const Option = styled.option`
  :disabled {
    color: ${select('gray50')};
  }
`;

const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  position: absolute;
  top: 12px;
  left: 40px;
  float: right;
  pointer-events: none;
  ${withQuery.xs.down()} {
    left: 80px;
    top: 16px;
    margin-left: 20px;
  }
  ${withQuery.xxs.down()} {
    font-size: 23px;
  }
`;

const SelectInput = React.memo(
  React.forwardRef(({ label = '', disableUnique = false, children, ...rest }, ref) => {
    const {
      onChangeSelect = () => {},
      onChangeInput = () => {},
      options = [],
      inputProps = {},
      selectId,
      inputId
    } = rest;
    return (
      <Container>
        <FeatureLabel htmlFor={selectId}>{label}</FeatureLabel>
        <OptionsContainer>
          <Select
            onChange={onChangeSelect}
            id={selectId}
            name={selectId}
            ref={ref}
            disabled={disableUnique && options.length < 2}
          >
            {options.map(option => (
              <Option value={option.value} key={`${option.value}-IdOption`}>
                {option.name}
              </Option>
            ))}
          </Select>
          <DropdownInput
            className={React.isValidElement(children) ? 'error' : ''}
            id={inputId}
            name={inputId}
            maxLength={12}
            max={999999999}
            onChange={onChangeInput}
            ref={ref}
            {...inputProps}
          />
          {children}
          <IconWrapper>
            <Icon name='chevronDown' width={36} height={36} viewBox='0 0 24 24' />
          </IconWrapper>
          {options.length === 1 && !disableUnique && <OneOptionView>{options[0].name}</OneOptionView>}
        </OptionsContainer>
      </Container>
    );
  })
);

export { SelectInput };
